import React, { useEffect, useMemo, useState } from 'react';
import { Box, Grid2, Container, Button, TextField, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Collapse } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getFilteredItemWiseSalesReport, getFilteredItemWiseSalesDeepDetailReport } from '../../features/StockReports/itemWiseSalesSlice';
import Navbar from '../setup/Navbar';
import StickyHeadTable from '../../BuiltInComponent/TableWithPagination';
import HeadingText from '../../BuiltInComponent/HeadingTest';
import { Document, Page, Text, View, pdf } from '@react-pdf/renderer';

const ItemWiseSalesReport = () => {
    const dispatch = useDispatch();
    const { reportData, deepDetailData } = useSelector((state) => state.iwsr);
    const getTodayDate = () => new Date().toISOString().split('T')[0];
    const [dateRange, setDateRange] = useState({ fromDate: getTodayDate(), toDate: getTodayDate(), orderType: 'all', reportView: 'summary' });
    const [expandedOrders, setExpandedOrders] = useState({});

    useEffect(() => {
        const payload = {
            fromDate: dateRange.fromDate,
            toDate: dateRange.toDate,
            orderType: dateRange.orderType
        };

        setExpandedOrders({});

        if (dateRange.reportView === 'deepDetail') {
            dispatch(getFilteredItemWiseSalesDeepDetailReport(payload));
            return;
        }

        dispatch(getFilteredItemWiseSalesReport(payload));
    }, [dispatch, dateRange.reportView]);

    const handleDateChange = (event) => {
        const { name, value } = event.target;
        setDateRange((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleGenerateReport = async () => {
        const payload = {
            fromDate: dateRange.fromDate,
            toDate: dateRange.toDate,
            orderType: dateRange.orderType
        };

        if (dateRange.reportView === 'deepDetail') {
            try {
                await dispatch(getFilteredItemWiseSalesDeepDetailReport(payload)).unwrap();
            } catch (error) {
                window.alert(error || 'Deep detail report load nahi ho saki. Backend server restart karke dobara try karein.');
            }
            return;
        }

        try {
            await dispatch(getFilteredItemWiseSalesReport(payload)).unwrap();
        } catch (error) {
            window.alert(error || 'Report load nahi ho saki. Backend server restart karke dobara try karein.');
        }
    };

    const handleToggleOrder = (orderID) => {
        setExpandedOrders((prev) => ({
            ...prev,
            [orderID]: !prev[orderID]
        }));
    };

    const handleExpandAllOrders = () => {
        const expandedMap = {};
        groupedDeepDetailData.forEach((order) => {
            expandedMap[order.orderID] = true;
        });
        setExpandedOrders(expandedMap);
    };

    const handleToggleAllOrders = () => {
        const allOpen = groupedDeepDetailData.length > 0
            && groupedDeepDetailData.every((order) => !!expandedOrders[order.orderID]);

        if (allOpen) {
            setExpandedOrders({});
            return;
        }

        handleExpandAllOrders();
    };

    const handleDownloadPDF = async () => {
        const SummaryPDF = () => (
            <Document>
                <Page size="A4" style={{ padding: 24 }}>
                    <View style={{ marginBottom: 12 }}>
                        <Text style={{ fontSize: 14, fontWeight: 'bold' }}>Item Wise Sales Report (Summary)</Text>
                        <Text style={{ fontSize: 10, marginTop: 4 }}>
                            Date From: {dateRange.fromDate}   Date To: {dateRange.toDate}
                        </Text>
                        <Text style={{ fontSize: 10, marginTop: 2 }}>
                            Order Type: {dateRange.orderType === 'all' ? 'All' : dateRange.orderType}
                        </Text>
                    </View>

                    <View style={{ borderWidth: 1, borderColor: '#d9d9d9' }}>
                        <View style={{ flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: '#d9d9d9', backgroundColor: '#f0f0f0' }}>
                            <Text style={{ width: '8%', fontSize: 9, padding: 4, fontWeight: 'bold' }}>#</Text>
                            <Text style={{ width: '16%', fontSize: 9, padding: 4, fontWeight: 'bold' }}>Code</Text>
                            <Text style={{ width: '30%', fontSize: 9, padding: 4, fontWeight: 'bold' }}>Item Name</Text>
                            <Text style={{ width: '14%', fontSize: 9, padding: 4, textAlign: 'right', fontWeight: 'bold' }}>Orders</Text>
                            <Text style={{ width: '14%', fontSize: 9, padding: 4, textAlign: 'right', fontWeight: 'bold' }}>Qty</Text>
                            <Text style={{ width: '18%', fontSize: 9, padding: 4, textAlign: 'right', fontWeight: 'bold' }}>Amount</Text>
                        </View>

                        {(reportData || []).map((item, index) => (
                            <View key={index} style={{ flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: '#efefef' }}>
                                <Text style={{ width: '8%', fontSize: 9, padding: 4 }}>{index + 1}</Text>
                                <Text style={{ width: '16%', fontSize: 9, padding: 4 }}>{item.itemCode || '-'}</Text>
                                <Text style={{ width: '30%', fontSize: 9, padding: 4 }}>{item.itemName || 'MISSING ITEM'}</Text>
                                <Text style={{ width: '14%', fontSize: 9, padding: 4, textAlign: 'right' }}>{Number(item.orderCount || 0).toLocaleString('en-US')}</Text>
                                <Text style={{ width: '14%', fontSize: 9, padding: 4, textAlign: 'right' }}>{Number(item.totalQty || 0).toLocaleString('en-US')}</Text>
                                <Text style={{ width: '18%', fontSize: 9, padding: 4, textAlign: 'right' }}>{Number(item.totalAmount || 0).toLocaleString('en-US')}</Text>
                            </View>
                        ))}

                        <View style={{ flexDirection: 'row', backgroundColor: '#f7f7f7' }}>
                            <Text style={{ width: '8%', fontSize: 9, padding: 4, fontWeight: 'bold' }}></Text>
                            <Text style={{ width: '16%', fontSize: 9, padding: 4, fontWeight: 'bold' }}>-</Text>
                            <Text style={{ width: '30%', fontSize: 9, padding: 4, fontWeight: 'bold' }}>TOTAL</Text>
                            <Text style={{ width: '14%', fontSize: 9, padding: 4, textAlign: 'right', fontWeight: 'bold' }}>{Number(summaryTotals.orders || 0).toLocaleString('en-US')}</Text>
                            <Text style={{ width: '14%', fontSize: 9, padding: 4, textAlign: 'right', fontWeight: 'bold' }}>{Number(summaryTotals.qty || 0).toLocaleString('en-US')}</Text>
                            <Text style={{ width: '18%', fontSize: 9, padding: 4, textAlign: 'right', fontWeight: 'bold' }}>{Number(summaryTotals.amount || 0).toLocaleString('en-US')}</Text>
                        </View>
                    </View>
                </Page>
            </Document>
        );

        const DeepDetailPDF = () => (
            <Document>
                <Page size="A4" style={{ padding: 24 }}>
                    <View style={{ marginBottom: 12 }}>
                        <Text style={{ fontSize: 14, fontWeight: 'bold' }}>Item Wise Sales Report (Deep Detail)</Text>
                        <Text style={{ fontSize: 10, marginTop: 4 }}>
                            Date From: {dateRange.fromDate}   Date To: {dateRange.toDate}
                        </Text>
                        <Text style={{ fontSize: 10, marginTop: 2 }}>
                            Order Type: {dateRange.orderType === 'all' ? 'All' : dateRange.orderType}
                        </Text>
                    </View>

                    {groupedDeepDetailData.map((order, orderIndex) => (
                        <View key={order.orderID} style={{ marginBottom: 10, borderWidth: 1, borderColor: '#d9d9d9' }}>
                            <View style={{ backgroundColor: '#f0f0f0', padding: 5 }}>
                                <Text style={{ fontSize: 9, fontWeight: 'bold' }}>
                                    {orderIndex + 1}. Order ID: {order.orderID} | Date: {formatOrderDateTime(order.orderDateTime, order.entDate).date} | Time: {formatOrderDateTime(order.orderDateTime, order.entDate).time}
                                </Text>
                                <Text style={{ fontSize: 9, marginTop: 2 }}>
                                    Type: {order.orderTypeDisplay} | Items: {order.noOfItems} | Qty: {Number(order.totalQty || 0).toLocaleString('en-US')} | Total: {Number(order.orderGrandTotal || 0).toLocaleString('en-US')}
                                </Text>
                            </View>

                            <View style={{ flexDirection: 'row', borderTopWidth: 1, borderTopColor: '#d9d9d9', backgroundColor: '#f8f8f8' }}>
                                <Text style={{ width: '10%', fontSize: 8, padding: 4, fontWeight: 'bold' }}>Code</Text>
                                <Text style={{ width: '34%', fontSize: 8, padding: 4, fontWeight: 'bold' }}>Item</Text>
                                <Text style={{ width: '10%', fontSize: 8, padding: 4, textAlign: 'right', fontWeight: 'bold' }}>Qty</Text>
                                <Text style={{ width: '14%', fontSize: 8, padding: 4, textAlign: 'right', fontWeight: 'bold' }}>Rate</Text>
                                <Text style={{ width: '14%', fontSize: 8, padding: 4, textAlign: 'right', fontWeight: 'bold' }}>Disc</Text>
                                <Text style={{ width: '18%', fontSize: 8, padding: 4, textAlign: 'right', fontWeight: 'bold' }}>Amount</Text>
                            </View>

                            {order.items.map((item, index) => (
                                <View key={`${order.orderID}-${index}`} style={{ flexDirection: 'row', borderTopWidth: 1, borderTopColor: '#efefef' }}>
                                    <Text style={{ width: '10%', fontSize: 8, padding: 4 }}>{item.itemCode || '-'}</Text>
                                    <Text style={{ width: '34%', fontSize: 8, padding: 4 }}>{item.itemName || '-'}</Text>
                                    <Text style={{ width: '10%', fontSize: 8, padding: 4, textAlign: 'right' }}>{Number(item.quantity || 0).toLocaleString('en-US')}</Text>
                                    <Text style={{ width: '14%', fontSize: 8, padding: 4, textAlign: 'right' }}>{Number(item.unitPrice || 0).toLocaleString('en-US')}</Text>
                                    <Text style={{ width: '14%', fontSize: 8, padding: 4, textAlign: 'right' }}>{Number(item.lineDiscount || 0).toLocaleString('en-US')}</Text>
                                    <Text style={{ width: '18%', fontSize: 8, padding: 4, textAlign: 'right' }}>{Number(item.lineTotal || 0).toLocaleString('en-US')}</Text>
                                </View>
                            ))}
                        </View>
                    ))}
                </Page>
            </Document>
        );

        const blob = await pdf(dateRange.reportView === 'deepDetail' ? <DeepDetailPDF /> : <SummaryPDF />).toBlob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${dateRange.reportView === 'deepDetail' ? 'Item_Wise_Sales_Deep_Detail' : 'Item_Wise_Sales'}_${dateRange.orderType}_${dateRange.fromDate}_to_${dateRange.toDate}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    };

    const summaryTotals = useMemo(() => {
        if (!reportData || reportData.length === 0) return { qty: 0, amount: 0, orders: 0 };
        return reportData.reduce((sum, item) => {
            return {
                qty: sum.qty + Number(item.totalQty || 0),
                amount: sum.amount + Number(item.totalAmount || 0),
                orders: sum.orders + Number(item.orderCount || 0)
            };
        }, { qty: 0, amount: 0, orders: 0 });
    }, [reportData]);

    const summaryTableData = useMemo(() => {
        if (!reportData || reportData.length === 0) return [];
        const rows = reportData.map((item, index) => ({
            rowNo: index + 1,
            ...item
        }));

        rows.push({
            rowNo: rows.length + 1,
            itemCode: '-',
            itemName: 'TOTAL',
            orderCount: summaryTotals.orders,
            totalQty: summaryTotals.qty,
            totalAmount: summaryTotals.amount
        });

        return rows;
    }, [reportData, summaryTotals]);

    const deepDetailTotals = useMemo(() => {
        if (!deepDetailData || deepDetailData.length === 0) return { qty: 0, amount: 0, orderCount: 0 };

        const uniqueOrders = new Set();
        const totals = deepDetailData.reduce((sum, row) => {
            uniqueOrders.add(row.orderID);
            return {
                qty: sum.qty + Number(row.quantity || 0),
                amount: sum.amount + Number(row.lineTotal || 0)
            };
        }, { qty: 0, amount: 0 });

        return {
            ...totals,
            orderCount: uniqueOrders.size
        };
    }, [deepDetailData]);

    const deepDetailTableData = useMemo(() => {
        if (!deepDetailData || deepDetailData.length === 0) return [];

        return deepDetailData.map((row, index) => {
            const normalizedOrderType = (row.orderType || '').toString().toLowerCase();
            const platform = (row.aggregatorPlatform || '').toString().toLowerCase();

            let orderTypeDisplay = row.orderType || '-';
            if (normalizedOrderType === 'dinein') orderTypeDisplay = 'DineIn';
            if (normalizedOrderType === 'takeaway') orderTypeDisplay = 'Takeaway';
            if (normalizedOrderType === 'delivery' && platform !== 'foodpanda') orderTypeDisplay = 'Delivery';
            if (normalizedOrderType === 'delivery' && platform === 'foodpanda') orderTypeDisplay = 'FoodPanda';

            return {
                rowNo: index + 1,
                orderID: row.orderID,
                entDate: row.entDate,
                orderDateTime: row.orderDateTime,
                orderTypeDisplay,
                itemCode: row.itemCode,
                itemName: row.itemName,
                quantity: Number(row.quantity || 0),
                unitPrice: Number(row.unitPrice || 0),
                lineDiscount: Number(row.lineDiscount || 0),
                lineTotal: Number(row.lineTotal || 0),
                orderGrandTotal: Number(row.orderGrandTotal || 0)
            };
        });
    }, [deepDetailData]);

    const groupedDeepDetailData = useMemo(() => {
        if (!deepDetailTableData || deepDetailTableData.length === 0) return [];

        const grouped = new Map();

        deepDetailTableData.forEach((row) => {
            if (!grouped.has(row.orderID)) {
                grouped.set(row.orderID, {
                    orderID: row.orderID,
                    entDate: row.entDate,
                    orderDateTime: row.orderDateTime,
                    orderTypeDisplay: row.orderTypeDisplay,
                    orderGrandTotal: row.orderGrandTotal,
                    noOfItems: 0,
                    totalQty: 0,
                    items: []
                });
            }

            const group = grouped.get(row.orderID);
            group.items.push(row);
            group.noOfItems += 1;
            group.totalQty += Number(row.quantity || 0);
        });

        return Array.from(grouped.values());
    }, [deepDetailTableData]);

    const formatOrderDateTime = (dateTimeValue, entDateValue) => {
        if (dateTimeValue) {
            const parsed = new Date(dateTimeValue);
            if (!Number.isNaN(parsed.getTime())) {
                return {
                    date: parsed.toLocaleDateString('en-GB'),
                    time: parsed.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })
                };
            }
        }

        return {
            date: entDateValue || '-',
            time: '-'
        };
    };

    const summaryTableColumns = useMemo(() => ([
        { fieldName: 'rowNo', cName: 'Row', textAlign: 'left', width: 40, status: 'dis', dType: 'number' },
        { fieldName: 'itemCode', cName: 'Item Code', textAlign: 'left', width: 100, status: 'en', dType: 'string' },
        { fieldName: 'itemName', cName: 'Item Name', textAlign: 'left', width: 200, status: 'en', dType: 'string' },
        { fieldName: 'orderCount', cName: 'Orders', textAlign: 'right', width: 80, status: 'en', dType: 'number' },
        { fieldName: 'totalQty', cName: 'Total Qty', textAlign: 'right', width: 90, status: 'en', dType: 'number' },
        { fieldName: 'totalAmount', cName: 'Amount', textAlign: 'right', width: 120, status: 'en', dType: 'number' },
        { fieldName: 'Edit', cName: 'Edit', textAlign: 'right', width: 80, status: 'dis', dType: 'string' },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'center', width: 80, status: 'dis', dType: 'string' },
        { fieldName: 'Extra', cName: 'Extra', textAlign: 'center', width: 80, status: 'dis', dType: 'string' }
    ]), []);

    const canDownload = dateRange.reportView === 'deepDetail'
        ? groupedDeepDetailData.length > 0
        : reportData && reportData.length > 0;

    const areAllOrdersOpen = groupedDeepDetailData.length > 0
        && groupedDeepDetailData.every((order) => !!expandedOrders[order.orderID]);

    return (
        <>
            <Navbar />
            <Container>
                <Box sx={{ p: 2 }}>
                    <HeadingText text="Item Wise Sales Report" />
                    <Box component="form" sx={{ flexGrow: 1, mt: 3 }}>
                        <Grid2 container spacing={2}>
                            <Grid2 size={3}>
                                <TextField
                                    fullWidth
                                    label="Date From"
                                    type="date"
                                    name="fromDate"
                                    value={dateRange.fromDate}
                                    onChange={handleDateChange}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid2>
                            <Grid2 size={3}>
                                <TextField
                                    fullWidth
                                    label="Date To"
                                    type="date"
                                    name="toDate"
                                    value={dateRange.toDate}
                                    onChange={handleDateChange}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid2>
                            <Grid2 size={3}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Report View"
                                    name="reportView"
                                    value={dateRange.reportView}
                                    onChange={handleDateChange}
                                >
                                    <MenuItem value="summary">Summary (Item Wise)</MenuItem>
                                    <MenuItem value="deepDetail">Deep Detail (Order + Item)</MenuItem>
                                </TextField>
                            </Grid2>
                            <Grid2 size={3}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Order Type"
                                    name="orderType"
                                    value={dateRange.orderType}
                                    onChange={handleDateChange}
                                >
                                    <MenuItem value="all">All</MenuItem>
                                    <MenuItem value="dinein">DineIn</MenuItem>
                                    <MenuItem value="takeaway">Takeaway</MenuItem>
                                    <MenuItem value="delivery">Delivery</MenuItem>
                                    <MenuItem value="foodpanda">FoodPanda</MenuItem>
                                </TextField>
                            </Grid2>
                            <Grid2 size={3}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    fullWidth
                                    onClick={handleGenerateReport}
                                >
                                    Generate Report
                                </Button>
                            </Grid2>
                            <Grid2 size={3}>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="large"
                                    fullWidth
                                    onClick={handleDownloadPDF}
                                    disabled={!canDownload}
                                >
                                    {dateRange.reportView === 'deepDetail' ? 'Download Deep Detail PDF' : 'Download Summary PDF'}
                                </Button>
                            </Grid2>
                            {dateRange.reportView === 'deepDetail' && (
                                <Grid2 size={3}>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        size="large"
                                        fullWidth
                                        onClick={handleToggleAllOrders}
                                        disabled={groupedDeepDetailData.length === 0}
                                    >
                                        {areAllOrdersOpen ? 'Close All Orders' : 'Open All Orders'}
                                    </Button>
                                </Grid2>
                            )}
                            <Grid2 size={12}>
                                {dateRange.reportView === 'summary' ? (
                                    <StickyHeadTable
                                        tableColumns={summaryTableColumns}
                                        tableData={summaryTableData}
                                        perPage={5}
                                        paginationStatus={false}
                                        textForTotal={'Total Amount'}
                                        total={summaryTotals.amount}
                                    />
                                ) : (
                                    <TableContainer component={Paper}>
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell width={140}>Action</TableCell>
                                                    <TableCell>Order ID</TableCell>
                                                    <TableCell align="right">No. Of Items</TableCell>
                                                    <TableCell align="right">Total Amount</TableCell>
                                                    <TableCell>Date</TableCell>
                                                    <TableCell>Time</TableCell>
                                                    <TableCell>Order Type</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {groupedDeepDetailData.map((order) => {
                                                    const dt = formatOrderDateTime(order.orderDateTime, order.entDate);
                                                    const isOpen = !!expandedOrders[order.orderID];

                                                    return (
                                                        <React.Fragment key={order.orderID}>
                                                            <TableRow>
                                                                <TableCell>
                                                                    <Button
                                                                        size="small"
                                                                        variant="outlined"
                                                                        onClick={() => handleToggleOrder(order.orderID)}
                                                                    >
                                                                        {isOpen ? 'Hide Items' : 'Show Items'}
                                                                    </Button>
                                                                </TableCell>
                                                                <TableCell>{order.orderID}</TableCell>
                                                                <TableCell align="right">{order.noOfItems}</TableCell>
                                                                <TableCell align="right">{Number(order.orderGrandTotal || 0).toLocaleString('en-US')}</TableCell>
                                                                <TableCell>{dt.date}</TableCell>
                                                                <TableCell>{dt.time}</TableCell>
                                                                <TableCell>{order.orderTypeDisplay}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell colSpan={7} sx={{ py: 0 }}>
                                                                    <Collapse in={isOpen} timeout="auto" unmountOnExit>
                                                                        <Box sx={{ m: 1 }}>
                                                                            <Table size="small">
                                                                                <TableHead>
                                                                                    <TableRow>
                                                                                        <TableCell>Item Code</TableCell>
                                                                                        <TableCell>Item Name</TableCell>
                                                                                        <TableCell align="right">Qty</TableCell>
                                                                                        <TableCell align="right">Rate</TableCell>
                                                                                        <TableCell align="right">Discount</TableCell>
                                                                                        <TableCell align="right">Amount</TableCell>
                                                                                    </TableRow>
                                                                                </TableHead>
                                                                                <TableBody>
                                                                                    {order.items.map((item, itemIndex) => (
                                                                                        <TableRow key={`${order.orderID}-${itemIndex}`}>
                                                                                            <TableCell>{item.itemCode || '-'}</TableCell>
                                                                                            <TableCell>{item.itemName || '-'}</TableCell>
                                                                                            <TableCell align="right">{Number(item.quantity || 0).toLocaleString('en-US')}</TableCell>
                                                                                            <TableCell align="right">{Number(item.unitPrice || 0).toLocaleString('en-US')}</TableCell>
                                                                                            <TableCell align="right">{Number(item.lineDiscount || 0).toLocaleString('en-US')}</TableCell>
                                                                                            <TableCell align="right">{Number(item.lineTotal || 0).toLocaleString('en-US')}</TableCell>
                                                                                        </TableRow>
                                                                                    ))}
                                                                                </TableBody>
                                                                            </Table>
                                                                        </Box>
                                                                    </Collapse>
                                                                </TableCell>
                                                            </TableRow>
                                                        </React.Fragment>
                                                    );
                                                })}
                                                {groupedDeepDetailData.length > 0 && (
                                                    <TableRow sx={{ backgroundColor: '#f7f7f7' }}>
                                                        <TableCell colSpan={2}><strong>TOTAL</strong></TableCell>
                                                        <TableCell align="right"><strong>{deepDetailTotals.orderCount}</strong></TableCell>
                                                        <TableCell align="right"><strong>{Number(deepDetailTotals.amount || 0).toLocaleString('en-US')}</strong></TableCell>
                                                        <TableCell colSpan={3}><strong>Qty: {Number(deepDetailTotals.qty || 0).toLocaleString('en-US')}</strong></TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                )}
                            </Grid2>
                        </Grid2>
                    </Box>
                </Box>
            </Container>
        </>

    );
};

export default ItemWiseSalesReport;
